package app.smartcoding.realrate.localization

import androidx.compose.runtime.Stable
import kotlinx.serialization.Serializable

@Stable
@Serializable
data class Strings(
    val analyzer: String,
    val appreciationOverview: String,
    val chartLegendInterest: String,
    val chartLegendPrincipal: String,
    val chartXaxisMonths: String,
    val chartYaxisPayment: String,
    val code: String,
    val costOfCredit: String,
    val creditDealAnalyzerDescription: String,
    val detailsGoodRateLongTerm: String,
    val detailsHighApr: String,
    val detailsHighInterestCost: String,
    val detailsHighRateShortTerm: String,
    val detailsLowApr: String,
    val detailsLowInterestCost: String,
    val discountsTradeIn: String,
    val displayName: String,
    val distribution: String,
    val downPayment: String,
    val effectiveApr: String,
    val headerBalance: String,
    val headerDate: String,
    val headerInterest: String,
    val headerMonth: String,
    val headerPayment: String,
    val headerPrincipal: String,
    val hideDetails: String,
    val interest: String,
    val invalidData: String,
    val loanAmountSupportingText: String,
    val loanDetails: String,
    val paymentSupportingText: String,
    val paymentComposition: String,
    val percentSymbol: String,
    val principal: String,
    val ratingBad: String,
    val ratingExcellent: String,
    val ratingFair: String,
    val ratingGood: String,
    val ratingPoor: String,
    val schedule: String,
    val showDetails: String,
    val summaryBad: String,
    val summaryExcellent: String,
    val summaryFair: String,
    val summaryGood: String,
    val summaryPoor: String,
    val totalPaid: String,
    val lockTaxRate: String,
    val unlockTaxRate: String,
    val currencySymbol: String,
    val currency: String,

    val totalCreditAmount: String,
    val taxAmount: String,
    val netAmountDisbursed: String, // Изчисляемо поле: totalCreditAmount - всички първоначални такси/данъци

    val years: String,
    val loanTermTotalMonths: String, // Изчисляемо или входно поле за общия срок

    val monthlyInstallment: String,
    val principalInstallment: String,
    val otherFees: String,
    val insuranceCost: String,

    val aprc: String, // Annual Percentage Rate of Charge (ГПР)
    val totalAmountPayable: String, // Обща сума за връщане
    val prepaidFeeFixed: String,
    val prepaidFeePercentage: String,
    val months: String,
    val description: String,
    val agree: String,
    val information: String,

    val errorCalculationOverflow: String,
    val errorTotalPaymentIsLessThanLoanAmount: String,
    val errorDivisionByZero: String,
    val errorNegativeResult: String,
    val errorRateTooHigh: String,
    val errorCalculation: String,

    val close: String,
    val hi: String,
    val guest: String,
    val account: String,
    val signInWithGoogle: String,
    val signOut: String,
    val settings: String,
    val about: String,
    val privacyPolicy: String,
    val termsOfService: String,

    val language: String,
    val theme: String,
    val light: String,
    val dark: String,
    val system: String,
    val toggleExpand: String,
)
